var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-section',[_c('ix-section-title',[_vm._v(_vm._s(_vm.$t('euTaxonomy.navigation.intro.label')))]),_vm._v(" "),_c('ix-section-text',[_c('div',{staticClass:"markdown-field",domProps:{"innerHTML":_vm._s(_vm.renderMarkdown(_vm.$t('euTaxonomy.content.intro')))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }